import { render, staticRenderFns } from "./AllocationOnlineGroup.vue?vue&type=template&id=9ad24fe2&"
import script from "./AllocationOnlineGroup.vue?vue&type=script&lang=js&"
export * from "./AllocationOnlineGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports